import { useCallback } from 'react';
import { useEditSceneModalStateContext } from 'containers/EditSceneModal/state';
import { Pixels } from 'utils/measurement';
import { measurementToViewport } from 'utils/placement';

export type UseCaptionsDragHandlersProps = {};

export default function useCaptionsDragHandlers() {
  const {
    dispatch,
    state: { previewDimensions },
  } = useEditSceneModalStateContext();

  const handleDragStart = useCallback(() => {
    dispatch({
      type: 'captions-drag-start',
    });
  }, [dispatch]);

  const handleDragStop = useCallback(
    (_e, dragData) => {
      if (!previewDimensions || !dragData) {
        return;
      }

      // convert snapped pixels to viewport units
      const vp = measurementToViewport(
        {
          left: new Pixels(dragData.x),
          top: new Pixels(dragData.y),
        },
        previewDimensions,
      );

      dispatch({
        type: 'captions-drag-stop',
        payload: {
          position: {
            left: vp.left.toString(),
            top: vp.top.toString(),
          },
        },
      });
    },
    [dispatch, previewDimensions],
  );

  return {
    handleDragStart,
    handleDragStop,
  };
}
